
import { computed, defineComponent, reactive } from 'vue';
import {
  Form, Input, InputNumber, Select, Button, Spin,
} from 'ant-design-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/delete.svg';
import '@/assets/icons/add.svg';
import asynButtonVue from '@/components/asynButton.vue';

const component = defineComponent({
  name: 'departmental-capacity',
  components: {
    SvgIcon,
    aForm: Form,
    aFormItem: Form.Item,
    aSelect: Select,
    aSelectOption: Select.Option,
    aTextarea: Input.TextArea,
    aInputNumber: InputNumber,
    aButton: asynButtonVue,
    aSpin: Spin,
  },
  props: {
    capacityList: {
      type: Array,
      default: () => [
        {
          abilityScore: 0,
          abilityType: 0,
          feedback: '',
        },
      ],
    },
    capacityDefaultList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    // 是否显示删除按钮，能力少于 1 个时不显示
    const isShowDel = computed(() => props.capacityList.length > 1);

    // 添加按钮禁用 能力 >= 8个时
    const addBtnDisable = computed(() => props.capacityList.length >= 8);

    const addCapacity = () => {
      context.emit('addAblilty');
    };

    const delCapacity = (index: number) => {
      context.emit('delAblilty', index);
    };

    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 16 },
      isShowDel,
      addBtnDisable,
      props,
      addCapacity,
      delCapacity,
    };
  },
});

export default component;
